// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import XRegExp from 'xregexp'
import { coordsDMS } from 'helpers/regex'
import { isWithinMinMaxVals } from 'validators/common'

import {
  LONGITUDE_DEGREE_RANGE,
  LONGITUDE_INVALID_FORMAT,
  LONGITUDE_OUTSIDE_BOUNDS,
  MINUTES_RANGE,
  SECONDS_RANGE,
  REQUIRED,
} from 'errors'

// validate long format and value
const validateLongitude = (value, error, notRequired) => {
  const dLong = XRegExp.exec(value, coordsDMS)?.groups || null

  // if the value's not required and the value's an empty string,
  // don't run any validation checks
  if (notRequired && !value) {
    return
  }

  if (!value) {
    error.longitude = REQUIRED
  } else if (
    // regex didn't match
    dLong === null ||
    // value passed regex but had both prefix and suffix (not sure how to control this in regex)
    (dLong.prefix && dLong.suffix)
  ) {
    error.longitude = LONGITUDE_INVALID_FORMAT
  } else if (dLong.suffix !== 'E' && dLong.suffix !== 'W') {
    error.longitude = 'Longitude direction can only be E or W.'
  } else if (!isWithinMinMaxVals(dLong.degrees, -180, 180)) {
    error.longitude = LONGITUDE_DEGREE_RANGE

  // because of formatting validation above, we can't actually
  // have mins that are less than 0.
  } else if (!isWithinMinMaxVals(dLong.minutes, 0, 59)) {
    error.longitude = MINUTES_RANGE

  // because of formatting validation above, we can't actually
  // have seconds that are less than 0.
  } else if (!isWithinMinMaxVals(`${dLong.seconds}.${dLong.milliseconds}`, 0, 59.99)) {
    error.longitude = SECONDS_RANGE

  // checks to see if min/seconds/milli are > 0 when deg is -180/180.
  } else if ((
    parseInt(dLong.degrees) === 180 ||
    parseInt(dLong.degrees) === -180
  ) && (
    dLong.minutes > 0 ||
    dLong.seconds > 0 ||
    dLong.milliseconds > 0
  )) {
    error.longitude = LONGITUDE_OUTSIDE_BOUNDS
  }
}

export default validateLongitude
